import { css } from 'lit';
export const swapButtonStyle = css ``;
//# sourceMappingURL=swap-button.style.js.map